import { render, staticRenderFns } from "./GlobalFilter.vue?vue&type=template&id=06f1dc2b&scoped=true&lang=pug"
import script from "./GlobalFilter.vue?vue&type=script&lang=js"
export * from "./GlobalFilter.vue?vue&type=script&lang=js"
import style0 from "./GlobalFilter.vue?vue&type=style&index=0&id=06f1dc2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1dc2b",
  null
  
)

export default component.exports